import AddUserPermissionContent from "../../Component/AddUserPermission/AddUserPermissionContent";

function AddUserPermission() {
  return <AddUserPermissionContent />
     
}

export default AddUserPermission;
